var React = require('react');

function FullscreenEnableInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"id":"fullscreen"},React.createElement("path",{"d":"M51,229.5H0V357h127.5v-51H51V229.5z M0,127.5h51V51h76.5V0H0V127.5z M306,306h-76.5v51H357V229.5h-51V306z M229.5,0v51\n\t\t\tH306v76.5h51V0H229.5z"}))));
}

FullscreenEnableInline.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"357px","height":"357px","viewBox":"0 0 357 357","style":{"enableBackground":"new 0 0 357 357"},"xmlSpace":"preserve"};

module.exports = FullscreenEnableInline;

FullscreenEnableInline.default = FullscreenEnableInline;
